export default {
    install(Vue, options) {
        Vue.mixin({
            data: () => ({
                asErrors: false,
                hasError: {},
                errorMsg: {},
                errorInputStyle: {},
                hasSuccess: false,
                successMsg: ""
            }),
            methods: {
                checkIfHasAnyError() {
                    this.hasErrors = Object.values(this.hasError).some(item => item === true);
                    return this.hasErrors;
                },
                setValidationFields(FieldsConstructor) {
                    this.hasError = new FieldsConstructor();
                    this.errorMsg = new FieldsConstructor();
                    this.errorInputStyle = new FieldsConstructor();
                    this.hasSuccess = new FieldsConstructor();
                    this.successMsg = new FieldsConstructor();
                },
                validateEmail(email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(String(email).toLowerCase());
                },
                validatePassword(password) {
                    var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[,.;\-~:<>'`^|=_+!@#\\$%\\^&\\*])(?=.{8,})/;
                    return re.test(String(password));
                },
                validateUsername(username) {
                    return username && username.length >= 8;
                },
                validateUserId(userId) {
                    var re = /\D+/;
                    return userId.length >= 5 && !re.test(userId);
                },
                validateCpfOrCnpj(value) {
                    return value && (value.length === 11 || value.length === 14);
                },
                showError(input, message) {
                    this.hasError[input] = true;
                    this.errorMsg[input] = message;
                    // this.msgClass[input] = "is-danger"
                    this.errorInputStyle[input] = {
                        borderColor: "red",
                        color: "red"
                    };
                },
                showSuccess(input, message) {
                    this.hasSuccess[input] = true;
                    this.successMsg[input] = message;
                    // this.msgClass[input] = "is-success"
                },
                hideSuccess(input) {
                    this.hasSuccess[input] = false;
                    this.successMsg[input] = "";
                },
                showOrHideError(input, isValid, message) {
                    let errorKey = convertToSnakeCase(input)
                    message = message || `invalid_${errorKey}`;
                    this.hasError[input] = isValid ? false : true;
                    this.errorMsg[input] = isValid ? "" : message;
                    this.errorInputStyle[input] = isValid ?
                        { borderColor: "#dad5d5", color: "#888484" } :
                        { borderColor: "red", color: "red" }
                },
                hideError(input) {
                    this.hasError[input] = false;
                    this.errorMsg[input] = "";
                    this.errorInputStyle[input] = {
                        borderColor: "grey",
                        color: "black"
                    };
                },
                isNumberValid(value) {
                    return value && !isNaN(value);
                },
                removeAllCharsNotNumber(event) {
                    let value = event.target.value;
                    if (value) {
                        event.target.value = value.replace(/\D/g, "");
                    }
                },
                // checkIfFormHasErrorsAndSubmit(form, sendFormFunc, afterSubmitFunc, afterSubmitError) {
                //     if (!this.checkIfHasAnyError()) {
                //         afterSubmitFunc = afterSubmitFunc || "";
                //         sendFormFunc(form)
                //             .then(afterSubmitFunc)
                //             .catch(afterSubmitError)
                //     } else {
                //         console.log("has errors:", this.hasError);
                //     }
                // },
                async checkIfFormHasErrorsAndSubmit(form, sendFormFunc, afterSubmitFunc, afterSubmitError) {
                    if (!this.checkIfHasAnyError()) {
                        afterSubmitFunc = afterSubmitFunc || "";
                        try {
                            let resp = await sendFormFunc(form)
                            afterSubmitFunc(resp)
                        } catch (e) {
                            afterSubmitError(e)
                        }

                    } else {
                        console.log("has errors:", this.hasError);
                    }
                },
                checkIfFormHasErrorsAndOpenModal(form, openModal, sendFormFunc) {
                    if (!this.checkIfHasAnyError()) {
                        openModal(form, sendFormFunc)
                    } else {
                        console.log("has errors:", this.hasError);
                    }
                },
                onChangeRemoveError(form, item, event) {
                    if (this.hasError[item]) {
                        this.showOrHideError(item, form[item])
                    }
                    if (event) {
                        this.removeAllCharsNotNumber(event)
                    }
                },
            }
        });
    }
};

function convertToSnakeCase(input) {
    return input.replace(/(?:^|\.?)([A-Z])/g, (x, y) => {
        return "_" + y.toLowerCase();
    }).replace(/^_/, "");
};


// WEBPACK FOOTER //
// ./src/utils/stratum_validation/index.js